/**
 * Collection page (sections/main-collection.liquid).
 *
 * Below 750px Horizon's filter drawer (#filters-drawer) is a bottom sheet (gh-collection.css).
 * Like the size guide, it closes by dragging its top edge (the grabber) down: past a quarter of
 * its height, or with a quick flick, it closes; otherwise it springs back.
 * Listeners sit on the document, so they survive Horizon re-rendering the section on filter.
 */
const GRAB_AREA = 48;
const DRAG_CLOSE_RATIO = 0.25;
const mobileQuery = window.matchMedia('(max-width: 749px)');

let drag = null;

/** @param {PointerEvent} event */
function onPointerDown(event) {
  if (!mobileQuery.matches || event.button !== 0) return;

  const panel = event.target instanceof Element ? event.target.closest('#filters-drawer .theme-drawer__dialog') : null;
  if (!(panel instanceof HTMLDialogElement) || !panel.open) return;

  const top = panel.getBoundingClientRect().top;
  if (event.clientY - top > GRAB_AREA) return;

  drag = { panel, startY: event.clientY, startTime: event.timeStamp, offset: 0, pointerId: event.pointerId };
  panel.classList.add('is-dragging');
  panel.setPointerCapture(event.pointerId);
  panel.addEventListener('pointermove', onPointerMove);
  panel.addEventListener('pointerup', onPointerUp);
  panel.addEventListener('pointercancel', onPointerUp);
}

/** @param {PointerEvent} event */
function onPointerMove(event) {
  if (!drag) return;
  drag.offset = Math.max(0, event.clientY - drag.startY);
  drag.panel.style.translate = `0 ${drag.offset}px`;
}

/** @param {PointerEvent} event */
function onPointerUp(event) {
  if (!drag) return;
  const { panel, offset, startTime, pointerId } = drag;
  drag = null;

  panel.removeEventListener('pointermove', onPointerMove);
  panel.removeEventListener('pointerup', onPointerUp);
  panel.removeEventListener('pointercancel', onPointerUp);
  if (panel.hasPointerCapture(pointerId)) panel.releasePointerCapture(pointerId);
  panel.classList.remove('is-dragging');

  const velocity = offset / Math.max(event.timeStamp - startTime, 1);
  const shouldClose = offset > panel.offsetHeight * DRAG_CLOSE_RATIO || (offset > 40 && velocity > 0.5);

  if (shouldClose) {
    const drawer = document.getElementById('filters-drawer');
    panel.addEventListener('close', () => panel.style.removeProperty('translate'), { once: true });
    if (drawer && 'close' in drawer && typeof drawer.close === 'function') drawer.close();
  } else {
    panel.style.removeProperty('translate');
  }
}

document.addEventListener('pointerdown', onPointerDown);
